import { html, ref, slotted } from "@microsoft/fast-element";
/**
 * Generates the template for the {@link @fabric-msft/fabric-web#MultiViewGroup} component.
 *
 * @public
 * @remarks
 * This template provides the HTML structure and bindings for the `MultiViewGroup` component.
 * It includes slots for `multi-view` and `controller`, and dynamically assigns properties
 * to control accessibility and interaction.
 *
 * @returns {ElementViewTemplate<MultiViewGroup>} The template for the `MultiViewGroup` component.
 *
 * @slot multi-view - Slot for the multiple views managed by the component.
 * @slot controller - Slot for the controllers that switch between views.
 *
 * @csspart views - The container for the views.
 * @csspart controllers - The container for the controllers.
 */
function multiViewGroupTemplate() {
    return html `
    <template>
      <div class="root">
        <div class="views" part="views">
          <slot name="multi-view" ${slotted("multiViews")}></slot>
        </div>
        <div
          class="controllers"
          part="controllers"
          role="tablist"
          aria-label="${(x) => x.ariaLabel}"
          tabindex="${(x) => (x.hidden ? "-1" : "0")}"
          ${ref("controllersContainer")}
        >
          <slot name="controller" ${slotted("controllers")}></slot>
        </div>
      </div>
    </template>
  `;
}
/**
 * The template for the {@link @fabric-msft/fabric-web#MultiViewGroup} component.
 * @public
 */
export const template = multiViewGroupTemplate();
//# sourceMappingURL=multi-view-group.template.js.map